module.exports = __webpack_public_path__ + "static/media/it.b46f8792.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/it.svg
// module id = 680
// module chunks = 0